import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgCornerUpRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.3 3.293a1 1 0 0 1 1.415 0l5 5a1.001 1.001 0 0 1 .249.414l.007.024a1 1 0 0 1 .006.51l-.013.05a.991.991 0 0 1-.077.184l-.012.02a.996.996 0 0 1-.16.212l-5 5-.076.068a1 1 0 0 1-1.407-1.406l.069-.076L17.594 10h-7.086c-1.545 0-2.599.436-3.34 1.035-.756.611-1.262 1.453-1.596 2.37-.677 1.862-.564 3.791-.564 4.095V20a1 1 0 0 1-2 0v-2.51l-.001-.034-.003-.111a15.596 15.596 0 0 1 .038-1.46c.067-.875.235-2.02.651-3.164.417-1.146 1.098-2.336 2.217-3.24C7.044 8.563 8.553 8 10.508 8h7.086L14.3 4.707a1 1 0 0 1 0-1.414Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgCornerUpRight)
